module.exports = __webpack_public_path__ + "pe-icon-set-weather.37a2798021056f527775.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/assets/fonts/pe/fonts/pe-icon-set-weather.svg?nlruav
// module id = ../../../../../src/assets/fonts/pe/fonts/pe-icon-set-weather.svg?nlruav
// module chunks = styles